import MinimalStyle from './MinimalStyle';
import AppStyle from './AppStyle';
import AssistantStyle from './AssistantStyle';

// Definimos los estilos de interfaz disponibles
export const INTERFACE_STYLES = {
  MINIMAL: 'minimal',
  APP: 'app',
  ASSISTANT: 'assistant'
};

// Mapeamos los estilos a sus componentes
export const STYLE_COMPONENTS = {
  [INTERFACE_STYLES.MINIMAL]: MinimalStyle,
  [INTERFACE_STYLES.APP]: AppStyle,
  [INTERFACE_STYLES.ASSISTANT]: AssistantStyle
};

// Función para obtener el componente de estilo correcto
export const getStyleComponent = (style) => {
  return STYLE_COMPONENTS[style] || STYLE_COMPONENTS[INTERFACE_STYLES.MINIMAL];
};